<template>
    <mindmap
      :nodes="OPERATION_nodes"
      :connections="OPERATION_connections"
      :editable="false"
    />
</template>

<script>
import Operation_sample from '@/data/Operation_mindmap_data.json'

export default {
  name: "Operation_mindmap",
  data() {
    return {
      OPERATION_nodes: Operation_sample['nodes'],
      OPERATION_connections: Operation_sample['connections'],
    }
  }

}
</script>

<style scoped>

</style>
